import { InjectionToken } from '@angular/core';

export interface LcaSearchApiConfiguration {
  projectServiceUrl: string;
  positionServiceUrl: string;
  articleServiceUrl: string;
  /** Base URL for EPD admin APIs (`/api/v2/admin`). */
  adminApiBaseUrl: string;
}

export const LCA_SEARCH_API_CONFIGURATION = new InjectionToken<LcaSearchApiConfiguration>(
  'LCA_SEARCH_API_CONFIGURATION',
);
